module.exports = __webpack_public_path__ + "static/media/legalPerson.8ab46275.svg";